  import { useMutation } from "@tanstack/react-query";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { query, where, getDocs, collection, updateDoc } from "firebase/firestore";
import { db } from "../../firebase/firebase"; 


const EXPIRATION_TIME = 1000 * 60 * 60 * 24; 
export const verifyUser = (): Promise<{ status: "verified" | "first_verify" | "not_verified" | "expired"}> => {
  return new Promise(async (resolve, reject) => {
    try {
      const auth = getAuth();
      const user = auth.currentUser;
      if (!user) {
        reject(new Error("No authenticated user found."));
        return;
      }

      const userInfoQuery = query(collection(db, "user_infos"), where("uid", "==", user.uid));
      const querySnapshot = await getDocs(userInfoQuery);

      if (querySnapshot.empty) {
        reject(new Error("User document not found."));
        return;
      }

      const userDoc = querySnapshot.docs[0].data() as { isVerified: boolean };

      if (userDoc.isVerified && user.emailVerified) {
        resolve({ status: "verified" });
      } else {

        const createdAt = querySnapshot.docs[0].data().createdAt;
        if (createdAt) {
          const elapsedTime = Date.now() - createdAt.toDate();
          if (elapsedTime > EXPIRATION_TIME) {
            resolve({ status: "expired" });
            return;
          }
        }

        const unsubscribe = onAuthStateChanged(auth, async (authUser) => {
          if (authUser && authUser.emailVerified) {
            await updateDoc(querySnapshot.docs[0].ref, { isVerified: true });
            resolve({ status: "first_verify" });
            unsubscribe();
          }else {
            resolve({ status: "not_verified" });
            unsubscribe();
          }
        });
      }

    } catch (error) {
      reject(error);
    }
  });
};


export const useUserVerification = () => {
  return useMutation({
    mutationFn: verifyUser,
  });
};
